const emojiQuiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "emoji-quiz",
    items: [
      { id: "q1", question: "🎤☔ ", answers: ["cantando bajo la lluvia"], image: null },
      { id: "q2", question: "🐍🐍✈️ ", answers: ["cobras en un avión"], image: null },
      { id: "q3", question: "👻🔫 ", answers: ["cazafantasmas"], image: null },
      { id: "q4", question: "🐼👊 ", answers: ["kung fu panda"], image: null },
      { id: "q5", question: "🏃‍♂️📦🍫 ", answers: ["forrest gump"], image: null },
      { id: "q6", question: "🦁👑 ", answers: ["lion king"], image: null },
      { id: "q7", question: "🌊🦈 ", answers: ["jaws"], image: null },
      { id: "q8", question: "🕷️👨 ", answers: ["spiderman"], image: null },
      { id: "q9", question: "❄️🛳️ ", answers: ["titanic"], image: null },
      { id: "q10", question: "🤫🐑🐑 ", answers: ["silence of the lambs"], image: null },
      { id: "q11", question: "🪐🦍🦍 ", answers: ["planet of the apes"], image: null },
    ],
  },
  botId: "nualang.emoji-quiz.0.0.1",
  botName: "emoji_quiz",
  description: "emoji_quiz_desc",
  difficulty: "ALL",
  learnLang: "spanish",
  name: "Conde Drácula",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwNi5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-smile?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Bienvenido a la prueba de las películas.
Organizado por el Conde Drácula.

¿Puedes nombrar las películas representadas por los emoticonos?
Algunos representan el título de la película, otros representan la trama.

Dile "Hola" al Conde Drácula para comenzar.`,
  voice: "Alonso",
  versionQuestion: "¿Cuántas preguntas le gustaría en esta plantilla?",
};

export default emojiQuiz;
